export default "__VITE_ASSET__DdL7Rk2S__"